import { render } from "./StatisticsPanel.vue?vue&type=template&id=1de202e8&ts=true"
import script from "./StatisticsPanel.vue?vue&type=script&lang=ts"
export * from "./StatisticsPanel.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\arind\\Documents\\scm\\easynwk-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__